import { IconPaymentAmex, IconPaymentMada, IconPaymentMastercard, IconPaymentTabby, IconPaymentTamaraLarge, IconPaymentTamaraLargeArabic, IconPaymentVisa } from "@repo/assets/images";
import cx from "classnames";
import { useLocale } from "next-intl";
const PaymentIcons = ({
  option,
  requiresMobileMultiLineLayout
}) => {
  const locale = useLocale();
  const isArabic = locale === "ar";
  const isTap = option === "TAP";
  const isARB = option === "ARB";
  const isPayfort = option === "PAYFORT";
  return <div className={cx("md:ms-auto", {
    "ms-auto": !requiresMobileMultiLineLayout
  })} data-sentry-component="PaymentIcons" data-sentry-source-file="PaymentIcons.jsx">
      <div className={cx("flex space-x-2 rtl:space-x-reverse", {
      "ps-0 pt-1 md:ps-8 md:pt-0": requiresMobileMultiLineLayout
    })}>
        {(isTap || isPayfort || isARB) && <>
            <IconPaymentVisa />
            <IconPaymentMastercard />
            <IconPaymentMada />
            <IconPaymentAmex />
          </>}
        {option === "TABBY" && <IconPaymentTabby />}
        {option === "TAMARA" && !isArabic && <IconPaymentTamaraLarge className="w-16 md:w-20" />}
        {option === "TAMARA" && isArabic && <IconPaymentTamaraLargeArabic className="w-16 md:w-20" />}
        {/*TODO: Removed below commented payfort option once approved */}
        {/*option === "PAYFORT" && <IconPaymentPayfort />*/}
      </div>
    </div>;
};
export default PaymentIcons;